export default "__VITE_ASSET__jpkNlDc$__"